// Type definition taken from @unibuddy/error-reporting,
// with STAGING removed as the staging environment is being torn down
type Environment = "DEV" | "QA" | "PRODUCTION";

// Function to convert UB_ENVIRONMENT env to Sentry env
export function getSentryEnv(nodeEnv: string): Environment {
    if (nodeEnv === "master") return "PRODUCTION";
    if (nodeEnv === "qa" && process.env.NODE_ENV !== "development") return "QA";
    return "DEV";
}
